import React from 'react';
import styled from 'styled-components';
import CloseButton from '../generic/CloseButton';
import WidgetSwitcher from './WidgetSwitcher';
import { widgetFont } from './widgetTypography';

const DragHandle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 20px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.font.color};
  opacity: 0.4;
`;

// A size container, so a widget can size its type and layout by the card it is
// in rather than by the window (widgetTypography.js)
const StyledDiv = styled.div`
  container-type: inline-size;
  container-name: widget;
  position: relative;
  background: ${({ theme }) => theme.card.background};
  border-radius: 1rem;
  overflow: hidden;
  padding: 0.75rem;
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  height: 100%;
  box-sizing: border-box;

  p {
    ${widgetFont.body}
  }
`;

const GridWidget = React.forwardRef(({
  style, className, onMouseDown, onMouseUp, onTouchEnd, children,
  isDraggable, handleDelete, type, widget,
  ...props
}, ref) => {
  return (
    <StyledDiv
      name="GridWidget"
      style={style}
      className={className}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      {isDraggable && (
        <DragHandle className="drag-handle">
          <svg width="16" height="8" viewBox="0 0 16 8" fill="currentColor">
            <circle cx="2" cy="2" r="1.5" />
            <circle cx="8" cy="2" r="1.5" />
            <circle cx="14" cy="2" r="1.5" />
            <circle cx="2" cy="6" r="1.5" />
            <circle cx="8" cy="6" r="1.5" />
            <circle cx="14" cy="6" r="1.5" />
          </svg>
        </DragHandle>
      )}
      <WidgetSwitcher type={type} />
      {isDraggable && (
        <CloseButton
          handleClick={() => handleDelete(widget.i)}
          $size="1rem"
          $padding="0rem 0.75rem"
          $top="5px"
        />
      )}
      {children}
    </StyledDiv>
  );
});

export default GridWidget;
